import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-association.reducer';

export const TenantAssociationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantAssociationEntity = useAppSelector(state => state.tenantAssociation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantAssociationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantAssociation.detail.title">TenantAssociation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.id">Id</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.id}</dd>
          <dt>
            <span id="associatedDate">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.associatedDate">Associated Date</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.associatedDate}</dd>
          <dt>
            <span id="internal">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.internal">Internal</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.internal ? 'true' : 'false'}</dd>
          <dt>
            <span id="leavingDate">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.leavingDate">Leaving Date</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.leavingDate}</dd>
          <dt>
            <span id="openingTime">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.openingTime">Opening Time</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.openingTime}</dd>
          <dt>
            <span id="closeTime">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.closeTime">Close Time</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.closeTime}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.modifiedBy}</dd>
          <dt>
            <span id="leftAssociation">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.leftAssociation">Left Association</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.leftAssociation ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.active">Active</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.timestampEntry}</dd>
          <dt>
            <span id="labAssociationType">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.labAssociationType">Lab Association Type</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.labAssociationType}</dd>
          <dt>
            <span id="tenantType">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.tenantType">Tenant Type</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.tenantType}</dd>
          <dt>
            <span id="otherTenantType">
              <Translate contentKey="tinyMedicRestApp.tenantAssociation.otherTenantType">Other Tenant Type</Translate>
            </span>
          </dt>
          <dd>{tenantAssociationEntity.otherTenantType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantAssociation.tenant">Tenant</Translate>
          </dt>
          <dd>{tenantAssociationEntity.tenant ? tenantAssociationEntity.tenant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantAssociation.associatedTenant">Associated Tenant</Translate>
          </dt>
          <dd>{tenantAssociationEntity.associatedTenant ? tenantAssociationEntity.associatedTenant.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-association" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-association/${tenantAssociationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantAssociationDetail;
